import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createSyncBlockNode } from '../utils/createSyncBlock';
import { ReferenceSyncBlockStoreManager } from './referenceSyncBlockStoreManager';
import { SourceSyncBlockStoreManager } from './sourceSyncBlockStoreManager';

// A store manager responsible for the lifecycle and state management of sync blocks in an editor instance.
// Supports create, read, update, and delete operations for sync blocks.
// Designed to manage local in-memory state and synchronize with an external data provider.
// Handles caching, debouncing updates, and publish/subscribe for local changes.
// Ensures consistency between local and remote state, and can be used in both editor and renderer contexts.
export var SyncBlockStoreManager = /*#__PURE__*/function () {
  function SyncBlockStoreManager(dataProvider) {
    _classCallCheck(this, SyncBlockStoreManager);
    this.referenceSyncBlockStoreManager = new ReferenceSyncBlockStoreManager(dataProvider);
    this.sourceSyncBlockStoreManager = new SourceSyncBlockStoreManager(dataProvider);
  }

  /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param nodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */
  return _createClass(SyncBlockStoreManager, [{
    key: "fetchSyncBlocksData",
    value: function fetchSyncBlocksData(nodes) {
      var syncBlockNodes = nodes.filter(function (node) {
        return node.type.name === 'syncBlock' && node.attrs.resourceId && node.attrs.localId;
      }).map(function (node) {
        return createSyncBlockNode(node.attrs.localId, node.attrs.resourceId);
      }) || [];
      if (syncBlockNodes.length === 0) {
        return Promise.resolve([]);
      }
      return this.referenceSyncBlockStoreManager.fetchSyncBlocksData(syncBlockNodes);
    }

    /**
     * Add/update a sync block node to/from the local cache
     * @param syncBlockNode - The sync block node to update
     */
  }, {
    key: "updateSyncBlockData",
    value: function updateSyncBlockData(syncBlockNode) {
      if (this.isSourceBlock(syncBlockNode)) {
        return this.sourceSyncBlockStoreManager.updateSyncBlockData(syncBlockNode);
      } else {
        throw new Error('Invalid sync block node type provided for updateSyncBlockData');
      }
    }

    /**
     * Save content of bodiedSyncBlock nodes in local cache to backend
     *
     * @returns true if saving all nodes successfully, false if fail to save some/all nodes
     */
  }, {
    key: "flushBodiedSyncBlocks",
    value: function flushBodiedSyncBlocks() {
      // only applicable to source sync block, for now (will be refactored further)
      return this.sourceSyncBlockStoreManager.flushBodiedSyncBlocks();
    }

    /**
     * Get the URL for a sync block.
     * @param resourceId - The resource ID of the sync block to get the URL for
     * @returns
     */
  }, {
    key: "getSyncBlockURL",
    value: function getSyncBlockURL(resourceId) {
      // only applicable to reference sync block, for now (will be refactored further)
      return this.referenceSyncBlockStoreManager.getSyncBlockURL(resourceId);
    }
  }, {
    key: "setEditorView",
    value: function setEditorView(editorView) {
      this.sourceSyncBlockStoreManager.setEditorView(editorView);
    }
  }, {
    key: "isSourceBlock",
    value: function isSourceBlock(node) {
      return node.type.name === 'bodiedSyncBlock';
    }
  }, {
    key: "registerConfirmationCallback",
    value: function registerConfirmationCallback(callback) {
      // only applicable to source sync block, for now (will be refactored further)
      return this.sourceSyncBlockStoreManager.registerConfirmationCallback(callback);
    }
  }, {
    key: "requireConfirmationBeforeDelete",
    value: function requireConfirmationBeforeDelete() {
      // only applicable to source sync block, for now (will be refactored further)
      return this.sourceSyncBlockStoreManager.requireConfirmationBeforeDelete();
    }
  }, {
    key: "createSyncBlockNode",
    value: function createSyncBlockNode() {
      // only applicable to source sync block, for now (will be refactored further)
      return this.sourceSyncBlockStoreManager.createSyncBlockNode();
    }
  }, {
    key: "subscribeToSyncBlockData",
    value: function subscribeToSyncBlockData(node, callback) {
      return this.referenceSyncBlockStoreManager.subscribe(node, callback);
    }
  }, {
    key: "refreshSubscriptions",
    value: function refreshSubscriptions() {
      this.referenceSyncBlockStoreManager.refreshSubscriptions();
    }
  }, {
    key: "deleteSyncBlocksWithConfirmation",
    value: function deleteSyncBlocksWithConfirmation(tr, syncBlockIds) {
      // only applicable to source sync block, for now (will be refactored further)
      return this.sourceSyncBlockStoreManager.deleteSyncBlocksWithConfirmation(tr, syncBlockIds);
    }
  }, {
    key: "rebaseTransaction",
    value: function rebaseTransaction(incomingTr, state) {
      // only applicable to source sync block, for now (will be refactored further)
      this.sourceSyncBlockStoreManager.rebaseTransaction(incomingTr, state);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.referenceSyncBlockStoreManager.destroy();
    }
  }]);
}();